import { RequestRoot } from "types";
import { IPrintDepartment } from "../model/print-department";

export abstract class PrintQRCodeGenerationService {
    abstract getEmbedQrCode(request: RequestRoot, deparment: IPrintDepartment): any;
    abstract getInetQrCode(request: RequestRoot): any;
    abstract getInetImageWidth(): number;
    abstract getInetImageHeight(): number;
    abstract getEmbedImageWidthNormal(): number;
    abstract getEmbedImageHeightNormal(): number;
    abstract getEmbedImageWidthLarge(): number;
    abstract getEmbedImageHeightLarge(): number;
    abstract getEmbedImageWidthHuge(): number;
    abstract getEmbedImageHeightHuge(): number;
}
